import { z as t } from "zod";
import { lineItemSchema as s, cartTotals as d, voucherSchema as a } from "@made-people/grease-cart";
import { customerAddressSchema as m, customerSchema as c } from "@made-people/grease-customer";
import { jsx as u } from "react/jsx-runtime";
import { createContext as n, useContext as o } from "react";
import { createEventEmitter as l } from "@made-people/grease-event-emitter";
const v = t.enum([
  /**
   * Completely new
   */
  "pending",
  /**
   * Order is being processed, which can mean that a warehouse
   * has received it. Not all platforms and e-commerce setups
   * have this distinction between pending and processing.
   */
  "processing",
  /**
   * Order is completed, ie shipped fully
   */
  "completed",
  /**
   * Order is cancelled, can happen anytime during the process,
   * except when it's completed
   */
  "cancelled",
  /**
   * Order is completely refunded
   */
  "refunded"
]), r = m.extend({
  firstName: t.string(),
  lastName: t.string(),
  email: t.string()
}), p = t.object({
  orderNumber: t.string(),
  currencyCode: t.string(),
  itemQuantity: t.number(),
  items: s.array(),
  totals: d,
  status: v,
  date: t.date(),
  paymentMethod: t.string(),
  shippingMethod: t.string(),
  additionalNotes: t.string().optional(),
  vouchers: a.array(),
  shippingAddress: r,
  billingAddress: r,
  customer: c.optional()
}), S = t.object({
  order: p
}), i = n(void 0), b = (e) => /* @__PURE__ */ u(i.Provider, { value: e, children: e.children }), C = () => {
  const e = o(i);
  return e || { additionalData: void 0 };
}, E = n(void 0), y = () => {
  const e = o(E);
  if (!e)
    throw new Error(
      "useOrderEventEmitter must be used inside a <OrderEventEmitterContext />"
    );
  return e;
}, D = l();
export {
  b as OrderEventAdditionalDataProvider,
  E as OrderEventEmitterContext,
  S as genericOrderReceiptProps,
  D as orderEventEmitter,
  p as orderSchema,
  v as orderStatus,
  C as useOrderEventAdditionalData,
  y as useOrderEventEmitter
};
